import React, { useEffect, useState } from "react";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

export default function AdminQuizQuestions() {
  const token = JSON.parse(localStorage.getItem("adminInfo") || "null")?.token;

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quizLive, setQuizLive] = useState(false);
  const [quizImage, setQuizImage] = useState(localStorage.getItem("quiz_banner_image") || null);
  const [showForm, setShowForm] = useState(false);

  const [newQuestion, setNewQuestion] = useState({
    text: "", choices: ["", "", "", ""], answerIndex: 0,
  });

  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState(null);

  /* --------------------------------------------------------
      LOAD ALL DATA
  -------------------------------------------------------- */
  useEffect(() => {
    fetchQuestions();
    fetchBanner();
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    try {
        const res = await fetch(`${API_BASE_URL}/api/quiz/status`);
        const data = await res.json();
        setQuizLive(data.quizLive);
    } catch (err) { console.error(err); }
  };

  const fetchQuestions = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/quiz/questions`);
      const data = await res.json();
      setQuestions(Array.isArray(data) ? data.reverse() : []);
    } catch (err) { console.error(err); } finally { setLoading(false); }
  };

  const toggleQuiz = async () => {
    await fetch(`${API_BASE_URL}/api/admin/quiz/toggle`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ disabled: quizLive }),
    });
    setQuizLive(!quizLive);
  };

  /* --------------------------------------------------------
      FETCH BANNER IMAGE
  -------------------------------------------------------- */
  const fetchBanner = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/quiz/banner`);
      const data = await res.json();
      const baseURL = API_BASE_URL.replace("/api", "");
      const full = `${baseURL}${data.image}`;
      setQuizImage(full);
      localStorage.setItem("quiz_banner_image", full);
    } catch (err) { console.log("Banner fetch error"); }
  };

  /* --------------------------------------------------------
      ADD QUESTION
  -------------------------------------------------------- */
  const handleAddQuestion = async () => {
    if (!newQuestion.text.trim()) return alert("Enter question text");
    if (newQuestion.choices.some((c) => c.trim() === "")) return alert("All choices required");

    try {
      const res = await fetch(`${API_BASE_URL}/api/quiz/questions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newQuestion),
      });
      if (!res.ok) throw new Error("Creation failed");
      alert("✅ Logic Fragment Added.");
      setNewQuestion({ text: "", choices: ["", "", "", ""], answerIndex: 0 });
      setShowForm(false);
      fetchQuestions();
    } catch (err) { alert(err.message); }
  };

  /* --------------------------------------------------------
      DELETE QUESTION
  -------------------------------------------------------- */
  const handleDelete = async (id) => {
    if (!window.confirm("Purge this logic fragment?")) return;
    try {
      await fetch(`${API_BASE_URL}/api/quiz/questions/${id}`, { method: "DELETE" });
      fetchQuestions();
    } catch (err) { console.error(err); }
  };

  /* --------------------------------------------------------
      UPDATE QUESTION
  -------------------------------------------------------- */
  const handleUpdateQuestion = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/quiz/questions/${editData._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editData),
      });
      if (!res.ok) throw new Error("Update failed");
      alert("✅ Logic Fragment Updated.");
      setEditMode(false);
      fetchQuestions();
    } catch (err) { alert(err.message); }
  };

  /* --------------------------------------------------------
      UPLOAD QUIZ BANNER IMAGE
  -------------------------------------------------------- */
  const handleQuizImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const form = new FormData();
    form.append("image", file);

    try {
      const res = await fetch(`${API_BASE_URL}/api/quiz/upload-image`, { method: "POST", body: form });
      const data = await res.json();
      if (data.success) {
        const baseURL = API_BASE_URL.replace("/api", "");
        const fullURL = `${baseURL}${data.url}`;
        setQuizImage(fullURL);
        localStorage.setItem("quiz_banner_image", fullURL);
        alert("✅ Banner deployed.");
      }
    } catch (err) { alert("Upload failed"); }
  };

  if (loading) return <div className="admin-list-container"><p style={{padding: '100px', textAlign: 'center'}}>⏳ Synchronizing Curriculum Buffer...</p></div>;

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Curriculum Forge</h1>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
             <button className="module-badge" style={{ cursor: 'pointer', background: '#4f46e5', border: 'none' }} onClick={() => setShowForm(!showForm)}>
                {showForm ? "View Grid" : "+ New Logic Fragment"}
            </button>
            <button className={`module-badge ${quizLive ? 'live' : 'closed'}`} style={{ cursor: 'pointer', border: 'none', background: quizLive ? '#10b981' : '#f43f5e' }} onClick={toggleQuiz}>
                {quizLive ? "QUIZ ACTIVE" : "QUIZ DISABLED"}
            </button>
        </div>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#4f46e5' }}></div>
            Operator: Assessment Architect Node
          </div>
          <div className="admin-status-badge" style={{ background: '#f5f3ff', color: '#4338ca', fontSize: '0.75rem', fontWeight: 800 }}>
             {questions.length} LOGIC FRAGMENTS COMMITTED
          </div>
        </div>

        {showForm ? (
            <div className="admin-table-wrapper" style={{ padding: '40px', background: '#fff' }}>
                 <h2 style={{ marginBottom: '30px', fontWeight: 800 }}>Fragment Provisioning</h2>
                 <div className="admin-form-elite" style={{ padding: 0, border: 'none', boxShadow: 'none' }}>
                    <label>Inquiry Text <input placeholder="State the assessment question..." value={newQuestion.text} onChange={e => setNewQuestion({...newQuestion, text: e.target.value})} /></label>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '20px' }}>
                        {newQuestion.choices.map((choice, idx) => (
                            <label key={idx}>Response Vector {idx+1} <input placeholder={`Candidate choice ${idx+1}`} value={choice} onChange={e => {
                                const upd = [...newQuestion.choices]; upd[idx] = e.target.value; setNewQuestion({...newQuestion, choices: upd});
                            }} /></label>
                        ))}
                    </div>
                    <label style={{ marginTop: '20px' }}>Correct Logic Node
                        <select value={newQuestion.answerIndex} onChange={e => setNewQuestion({...newQuestion, answerIndex: Number(e.target.value)})}>
                            <option value="0">Vector 1</option>
                            <option value="1">Vector 2</option>
                            <option value="2">Vector 3</option>
                            <option value="3">Vector 4</option>
                        </select>
                    </label>
                    <div style={{ marginTop: '40px', display: 'flex', gap: '15px' }}>
                        <button className="btn-primary-elite" onClick={handleAddQuestion} style={{ width: '220px', background: '#4f46e5' }}>Commit Fragment</button>
                        <button className="btn-update" onClick={() => setShowForm(false)} style={{ border: 'none', background: '#f1f5f9' }}>Cancel</button>
                    </div>
                 </div>
            </div>
        ) : (
            <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', gap: '30px', marginBottom: '30px' }}>
                     <div className="admin-asset-card" style={{ height: 'fit-content' }}>
                        <div className="asset-preview">
                            <img src={quizImage || "/placeholder.jpg"} alt="Banner" />
                            <div className="asset-tag">BANNER ASSET</div>
                        </div>
                        <div className="asset-info">
                            <input type="file" id="bannerUp" hidden onChange={handleQuizImageUpload} />
                            <button className="btn-primary-elite" style={{ width: '100%', fontSize: '0.8rem' }} onClick={() => document.getElementById('bannerUp').click()}>
                                Upload New Landing Identity
                            </button>
                        </div>
                     </div>
                     <div className="admin-table-wrapper" style={{ margin: 0 }}>
                        <table className="elite-table">
                            <thead>
                                <tr>
                                    <th>Index</th>
                                    <th>Logic Fragment</th>
                                    <th>Resolution</th>
                                    <th>Operations</th>
                                </tr>
                            </thead>
                            <tbody>
                                {questions.map((q, i) => (
                                    <tr key={q._id}>
                                        <td>{i + 1}</td>
                                        <td style={{ maxWidth: '400px' }}>
                                            <div style={{ fontWeight: 700, marginBottom: '10px' }}>{q.text}</div>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}>
                                                {q.choices.map((c, idx) => (
                                                    <div key={idx} style={{ fontSize: '0.75rem', padding: '4px 8px', borderRadius: '4px', background: q.answerIndex === idx ? '#d1fae5' : '#f8fafc', color: q.answerIndex === idx ? '#065f46' : '#64748b', border: q.answerIndex === idx ? '1px solid #10b981' : '1px solid #e2e8f0' }}>
                                                        {idx+1}. {c}
                                                    </div>
                                                ))}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ fontWeight: 800, color: '#10b981' }}>VECTOR {q.answerIndex + 1}</div>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <button className="action-btn-elite btn-update" onClick={() => { setEditData({...q}); setEditMode(true); }}><span>✏️</span></button>
                                                <button className="action-btn-elite btn-delete" onClick={() => handleDelete(q._id)}><span>🗑️</span></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                     </div>
                </div>
            </>
        )}
      </div>

      {editMode && editData && (
        <div className="admin-form-overlay" style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(15, 23, 42, 0.4)', backdropFilter: 'blur(8px)',
            display: 'flex', justifyContent: 'flex-end', zIndex: 1000
        }} onClick={() => setEditMode(false)}>
            <div className="admin-side-panel" style={{
                width: '450px', height: '100%', background: '#fff', 
                boxShadow: '-20px 0 50px rgba(0,0,0,0.1)', padding: '40px',
                display: 'flex', flexDirection: 'column', gap: '25px',
                animation: 'slideIn 0.4s ease-out'
            }} onClick={e => e.stopPropagation()}>
                <h2 style={{ fontWeight: 800, color: '#0f172a' }}>Modify Fragment</h2>
                <div className="admin-form-elite" style={{ padding: 0, border: 'none', boxShadow: 'none' }}>
                    <label>Inquiry Text <input value={editData.text} onChange={e => setEditData({...editData, text: e.target.value})} /></label>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '15px' }}>
                        {editData.choices.map((choice, idx) => (
                             <label key={idx} style={{ margin: 0 }}>Response Vector {idx+1} <input value={choice} onChange={e => {
                                 const upd = [...editData.choices]; upd[idx] = e.target.value; setEditData({...editData, choices: upd});
                             }} /></label>
                        ))}
                    </div>
                    <label style={{ marginTop: '15px' }}>Correct Logic Node
                        <select value={editData.answerIndex} onChange={e => setEditData({...editData, answerIndex: Number(e.target.value)})}>
                            <option value="0">Vector 1</option>
                            <option value="1">Vector 2</option>
                            <option value="2">Vector 3</option>
                            <option value="3">Vector 4</option>
                        </select>
                    </label>
                </div>
                <div style={{ marginTop: 'auto', display: 'flex', gap: '10px' }}>
                    <button className="btn-primary-elite" onClick={handleUpdateQuestion} style={{ flex: 1, background: '#4f46e5' }}>Update Logic</button>
                    <button className="btn-update" onClick={() => setEditMode(false)} style={{ flex: 1, border: 'none', background: '#f1f5f9' }}>Cancel</button>
                </div>
            </div>
        </div>
      )}
    </div>
  );
}
